<template>
  <v-dialog max-width="400" v-model="isSectionDeleteDialog">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        color="#ff575f"
        class="white2--text btn-delete text-delete"
        v-if="isMtOrganizer || isSectionOrganizer"
        @click="openDialog"
      >
        <span style="position: relative; display: block; font-size: 12px">{{ 'Delete Section' }}</span>
      </v-btn>
      <v-btn
        v-bind="attrs"
        v-on="on"
        icon
        class="icon-delete"
        color="#ccc"
        v-if="isMtOrganizer || isSectionOrganizer"
        @click="openDialog"
      >
        <v-icon size="26">mdi-delete</v-icon>
      </v-btn>
    </template>
    <v-card class="container-section-delete px-5 py-3" color="#21343b" width="auto">
      <v-row no-gutters align="center" justify="center">
        <v-col class="px-5 mt-2" :cols="12" align="start" justify="start">
          <span class="delete-section-title">{{ $t('deleteSection') }}</span>
        </v-col>
        <v-col class="px-5 mt-2" :cols="12" align="start" justify="center">
          <span class="delete-section-content">{{ $t('deleteSectionContent') }}</span>
        </v-col>
        <v-row class="d-flex flex-nowrap container-btn my-4 mx-5" no-gutters align="start" justify="center">
          <v-btn
            width="120"
            height="40"
            elevation="0"
            color="#ff575f"
            :loading="isDeleteLoading"
            @click="deleteSection"
            class="mr-5"
          >
            {{ $t('delete') }}
          </v-btn>
          <v-btn width="120" height="40" elevation="0" color="#869399" @click="isSectionDeleteDialog = false">
            {{ $t('cancel') }}
          </v-btn>
        </v-row>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { setDeleteSection } from '@/services/sectionApi'
import Toast from '@/views/meeting/component/Toast'
import { isMobile } from '@/common/lib/strLib'
import { mapState } from 'vuex'

export default {
  name: 'SectionDeleteDialog',
  props: ['sectionInfo', 'userInfo'],
  data() {
    return {
      isSectionDeleteDialog: false,
      isDeleteLoading: false,
    }
  },
  methods: {
    openDialog() {
      this.$store.dispatch('setIsPlayerForceStop', !this.$store.getters.isPlayerForceStop)
    },
    async deleteSection() {
      try {
        this.isDeleteLoading = true
        await setDeleteSection(this, this.mtInfo.wsId, this.computedSectionInfo.stId, this.computedSectionInfo.mtId)
        // 섹션이 삭제되었을 시 workspace 의 총 클립 갯수를 새롭게 업데이트 시켜준다.
        this.$store.dispatch('setWsClipCnt', {
          wsDomain: this.$route.params['wsDomain'],
          userId: this.userInfo ? this.userInfo['userId'] : null,
        })
        let index = this.totalSectionList.findIndex((section) => section.stId === this.computedSectionInfo.stId)

        let toDeleteSection = index >= 0 ? this.totalSectionList[index] : null

        this.$store.dispatch('setDeleteSection', toDeleteSection)
        this.isSectionDeleteDialog = false
        // notify(this, 'Success', this.$t('deleteSectionSuccess'), 'success')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('deleteSectionSuccess'),
            // submsg: '',
          },
        }
        this.$toast.success(content)
      } catch (error) {
        console.log(error)
        // notify(this, 'Error', this.$t('general.error'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('general.error'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
      } finally {
        this.isDeleteLoading = false
      }
    },
  },
  computed: {
    isMobile() {
      return isMobile()
    },
    computedSectionInfo() {
      return this.sectionInfo !== undefined && this.sectionInfo !== null ? this.sectionInfo : {}
    },
    isSectionOrganizer() {
      return (
        this.sectionInfo !== undefined &&
        this.sectionInfo !== null &&
        this.userInfo !== undefined &&
        this.userInfo !== null &&
        this.sectionInfo.stCreatorUid === this.userInfo.userId
      )
    },

    ...mapState({
      isMtOrganizer: (state) => {
        if (
          state &&
          state !== null &&
          state.auth &&
          state.auth !== null &&
          state.auth.currentMt &&
          state.auth.currentMt !== null &&
          state.auth.userInfo &&
          state.auth.userInfo !== null
        ) {
          return state.auth.currentMt.mtOrganizerUid === state.auth.userInfo.userId
        } else {
          return false
        }
      },
      mtInfo: (state) => {
        return state.auth.currentMt
      },
      wsInfo: (state) => {
        return state.auth.selectedWsInfo
      },
      totalSectionList: (state) => {
        return state.clip.totalSectionList
      },
    }),
  },
}
</script>

<style scoped>
.v-dialog__content >>> .v-dialog {
  overflow: hidden;
}
.container-section-delete {
  border-radius: 10px;
}
.delete-section-title {
  font-weight: bold;
  font-size: 20px;
  color: white;
}

.delete-section-content {
  font-size: 14px;
  color: #96a7af;
}
.container-btn >>> .v-btn * {
  font-size: 14px;
  color: white;
  letter-spacing: 0;
  text-transform: none;
  font-weight: bold;
}
.icon-delete {
  display: none;
}
.text-delete {
  display: inline-block;
}
.btn-delete {
  margin-left: 20px !important;
}
@media (max-width: 1263px) {
  .btn-delete {
    margin-left: 12.5px;
  }
}
@media (max-width: 768px) {
  .btn-delete {
    margin-left: 5px;
  }
}
@media (max-width: 1263px) {
  .icon-delete {
    display: inline-block;
  }
  .text-delete {
    display: none;
  }
}
</style>
